import React, { Component, Fragment } from "react";
import { string, node, oneOfType } from "prop-types";

import Image from "pages/_components/Image";
import Container from "pages/_components/Container";
import { Col, Row } from "react-bootstrap";

class GeneralMsg extends Component {
    static propTypes = {
        title: oneOfType([string, node]),
        description: oneOfType([string, node]),
        imagePath: string,
        pageTitle: node,
        callToAction: node,
        errorCode: string,
    };

    static defaultProps = {
        title: null,
        description: null,
        imagePath: null,
        pageTitle: null,
        callToAction: null,
        errorCode: null,
    };

    render() {
        const { title, description, imagePath, callToAction, pageTitle, errorCode } = this.props;

        return (
            <Fragment>
                {pageTitle}
                <Container aria-live="polite" className="icon-message-page container--layout items-center flex-grow">
                    <Container.Column xs={12} md={10} mdOffset={1} className="icon-message-page--error-container">
                        {title && <h1 className="icon-message-page--title">{title}</h1>}
                        {imagePath && <Image src={imagePath} className="svg-big-icon icon-message-page--image" />}
                        {errorCode && <p className="icon-message-page--description">Código {errorCode}</p>}
                        {description && (
                            <p className="icon-message-page--description box box-border-soft">{description}</p>
                        )}
                    </Container.Column>
                    {callToAction && (
                        <Row className="form-actions">
                            <Col xs={12} md={4} mdOffset={4} className="icon-message-page--button">
                                {callToAction}
                            </Col>
                        </Row>
                    )}
                </Container>
            </Fragment>
        );
    }
}

export default GeneralMsg;
